import { UsageRuleAdapter as t } from "../usageRule/usageRule.adapter.js";
import { VoucherSettingsModel as r } from "./voucherSettings.model.js";
import { Adapter as i, getAdapter as n } from "../../../adapter.js";
class _ extends i {
  adapt(e) {
    const o = n(t);
    return new r({
      refId: e.ref_id,
      duration: e.duration,
      terms: e.terms,
      font: e.font,
      textColor: e.text_color,
      highlightTextColor: e.highlight_text_color,
      backgroundColor: e.background_color,
      buttonColor: e.button_color,
      spentButtonColor: e.spent_button_color,
      textButtonColor: e.text_button_color,
      name: e.name,
      image: e.image,
      logo: e.logo,
      title: e.title,
      redeemMethod: Number(e.redeem_method),
      externalPromotionId: e.external_promotion_id,
      externalSuccessPromotionId: e.external_success_promotion_id,
      startDatetime: e.start_datetime ? new Date(e.start_datetime * 1e3) : void 0,
      isUnlimited: !!e.is_unlimited,
      maximumUses: e.maximum_uses ?? -1,
      usageRules: (e.usage_rules ?? []).map(o.adapt),
      requiresVerifiedPhone: e.requires_verified_phone
    });
  }
  serialize(e) {
  }
}
export {
  _ as VoucherSettingsAdapter
};
//# sourceMappingURL=voucherSettings.adapter.js.map
